import { RouteRecordRaw } from "vue-router";
import { ROLES_AND_PERMISSION_ON_ROUTES } from "@/core/configs/rolesAndPermissionsMappingOnRoutes";

const routes: Array<RouteRecordRaw> = [
  {
    path: "",
    name: "fareManagement",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.FARE_MANAGEMENT.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.FARE_MANAGEMENT.PERMISSIONS,
    },
    component: () =>
      import("@/modules/FareManagement/views/fareManagement.vue"),
  },
];

export default routes;
